import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 1.3rem;
`;

export const Th = styled.th`
  text-align: ${(props) => props.$align || 'left'};
  padding: 4px 8px;
  border-bottom: 2px solid #ccc;
  color: #333;
`;

export const Td = styled.td`
  text-align: ${(props) => props.$align || 'left'};
  padding: 4px 8px;
  border-radius: 6px;
  vertical-align: middle;
`;

export const Tr = styled.tr`
  background: ${(props) => (props.$isSelected ? '#E0EFFF' : props.$alternate ? '#F9F9F9' : '#ffffff')};
  cursor: ${(props) => (props.$onClick ? 'pointer' : 'default')};

  &:hover {
    background-color: ${(props) => (props.$isSelected ? '#D0E5FF' : '#F8F8F8')};
  }
`;

export const NoDataMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: #777;
  font-style: italic;
`;

export const AddButton = styled.button`
  background: none;
  color: #FA9A1C;
  font-weight: bold;
  border: none;
  margin-top: 12px;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

export const Input = styled.input`
    padding: 0px 4px;
  width: 100%;
`;

export const Icon = styled.i`
    color:#5D5D5D;
    margin:6px;
    cursor:pointer;
    font-size: 1.5rem;

    &.pf-add { color: #FA9A1C; margin: 0; font-size: 1.1rem;}
`;

export const ErrorText = styled.div`
  color: red;
  font-size: 1rem;
  margin-top: 4px;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 12px;
  height: 12px;
  font-size: 1.1rem;
  cursor: pointer;
`;
